import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const REAL_ESTATE_DOMAIN_INTRO = {
  title: "Real Estate & Construction",
  content: "Agentic AI workflow automation for Real Estate & Construction — across Construction project operations. Use cases span tender document review and variation order impact summary with governed workflow automation, human review, and audit evidence. Practical deployments for developers and contractors in India, UAE, KSA, UK, and USA.",
  seoDescription: "Real estate construction agentic AI — tender document review, variation order impact summary. Project management ERP document management CRM integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const REAL_ESTATE_SYSTEMS = "Project Management, ERP, Document Management, CRM, Email, Power BI";

const RAW = [
  {
    id: "tender-document-review",
    subIndustry: "Construction",
    department: "Pre-Sales",
    businessProcess: "Tender document review",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Tender document review",
    title: "Tender Document Review Automation for Real Estate & Construction",
    seoKeywords: "real estate & construction, tender document review, AI automation, RPA, agentic AI, document AI",
    challenge: "Bid teams manually review long tender documents, forms, deadlines and eligibility clauses.",
    solution: "Implement Agentic AI + Document AI to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Construction teams can improve tender document review with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Document AI",
    buyerPersona: "Business Development Head",
    systems: REAL_ESTATE_SYSTEMS,
    agentsRequired: "Document Extraction Agent, Tender Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and tender document review rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready tender document review record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "variation-order-impact-summary",
    subIndustry: "Construction",
    department: "Commercial",
    businessProcess: "Variation order impact summary",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Variation order impact summary",
    title: "Variation Order Impact Summary Automation for Real Estate & Construction",
    seoKeywords: "real estate & construction, variation order impact summary, AI automation, RPA, agentic AI, document AI",
    challenge: "Variation requests are manually reviewed for cost, schedule and contract impact.",
    solution: "Implement Agentic AI + Document AI to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Construction teams can improve variation order impact summary with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Document AI",
    buyerPersona: "Commercial Head, Project Director",
    systems: REAL_ESTATE_SYSTEMS,
    agentsRequired: "Document Extraction Agent, Variation Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and variation order impact summary rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready variation order impact summary record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const REAL_ESTATE_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Construction"];
export const REAL_ESTATE_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => REAL_ESTATE_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'real-estate-domain', domainIntro: REAL_ESTATE_DOMAIN_INTRO, useCases: REAL_ESTATE_USE_CASES });
export const REAL_ESTATE_USE_CASES_SEO = seo.useCasesSeo;
export const REAL_ESTATE_DOMAIN_FAQS = seo.domainFaqs;
export const REAL_ESTATE_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const REAL_ESTATE_FAQ_JSONLD = seo.faqJsonLd;
export const REAL_ESTATE_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const REAL_ESTATE_WEBPAGE_JSONLD = seo.webPageJsonLd;

